import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/operation_log_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  event_eq: {
    model_name: 'OperationLog',
    column_type: 'string',
    column_name: 'event',
  },
  operator_id_eq: {
    model_name: 'OperationLog',
    column_type: 'string',
    column_name: 'operatorId',
  },
  target_id_eq: {
    model_name: 'OperationLog',
    column_type: 'string',
    column_name: 'targetId',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('OperationLog', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('OperationLog', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
